<template>
  <div class="home">
    <!-- <div v-if="innerWidth > 1000"> -->
      <CruuencyPc></CruuencyPc>
    <!-- </div> -->
    <!-- <div v-else> -->
      <!-- <HomeM></HomeM> -->
    <!-- </div> -->
  </div>
</template>

<script>
// @ is an alias to /src
import CruuencyPc from "./components/cruuency_pc.vue";
import { mapState } from "vuex";
export default {
  name: "CruuencyView",
  data() {
    return {};
  },
  mounted() {},
  computed: {
    ...mapState(["innerWidth"]),
  },
  components: {
    CruuencyPc,
    // HomeM,
  },
};
</script>
